export const TOUCHSCREEN_MAX_WIDTH = 1024;
export const TOUCHSCREEN_DEVICES = ['mobile', 'tablet'];
export const DESKTOP_DEVICES = ['desktop'];
